module.exports = __webpack_public_path__ + "static/media/logdaysSliderImg.12b16d29.png";